import React from "react";

import { Container, OrdersIframe, OrdersIframeMob } from "./styles";

function Orders() {
  const accessToken = localStorage.getItem("token") || "";
  return (
    <Container>
      <OrdersIframe
        src={`https://mindi-gerencial.bubbleapps.io/orders?accessToken=${accessToken}`}
      ></OrdersIframe>
      {/* <OrdersIframeMob
        src={`https://mindi-gerencial.bubbleapps.io/version-test/orders_mob?accessToken=${accessToken}`}
      ></OrdersIframeMob> */}
    </Container>
  );
}

export default Orders;
